import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { makeStyles } from "@mui/styles";
import classNames from "classnames";

const useStyles = makeStyles({
  infoMessageRoot: {
    boxShadow: "0px 8px 16px rgba(143,23,1,0.1)",
    borderRadius: "8px",
    padding: 8,
    color: "green"
  },
  infoVariant: {
    background: "#F2FAFF",
    boxShadow: "0px 8px 16px rgba(1,64,128,0.1)",
    color: "#02569D",
  },
  successVariant: {
    background: "#EDFFF7",
    boxShadow: "0px 8px 16px rgba(0,130,91,0.1)",
    color: "#35E9A8",
  },
  errorVariant: {
    backgroundColor: "#FFF0F0",
    boxShadow: "0px 8px 16px rgba(143, 23, 1, 0.1)",
    color: "#F55446",
  },
});

function InfoMessage({ children, variant = 'info' }) {
  const classes = useStyles();
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      className={classNames(
        classes.infoMessageRoot,
        variant === 'info' ? classes.infoVariant : {},
        variant === 'error' ? classes.errorVariant : {},
        variant === 'success' ? classes.successVariant : {},
      )}
      p={2}
      width="fit-content"
    >
      <ErrorOutlineIcon color="inherit" fontSize="small" />
      <Typography
        variant="caption"
        component="div"
        color={"inherit"}
        fontWeight="bold"
        p={1}
      >
        {children}
      </Typography>
    </Box>
  );
}

export default InfoMessage;